import type { ComponentProps } from 'react'
import { createActorContext } from '@xstate/react'
import type { AnyStateMachine } from 'xstate'

export function createAppActorContext<TMachine extends AnyStateMachine>(machine: TMachine) {
  const context = createActorContext(machine)

  type ProviderProps = ComponentProps<typeof context.Provider>

  const Provider = ({ children, ...rest }: ProviderProps) => {
    return <context.Provider {...rest}>{children}</context.Provider>
  }
  Provider.displayName = 'AppActorProvider'

  return { AppActorContext: context, AppActorProvider: Provider }
}
